import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the moveVariation method
 */
export function createMoveVariation(context: API.Context) {
  return function moveVariation(lineId: number, up: boolean): API.Response {
    const { game, respond } = context;

    // attempt to move the variation
    const moved = game.moveVariation(lineId, up);

    if (!moved) {
      return null;
    }

    return respond(Core.APIEvents.MoveVariation);
  };
}
